var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"sign-up-page"}},[_c('SignUpTabs',{staticClass:"c-max-w"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }